<template>
    <div>
        <div class="edit-title">schema配置</div>
        <el-tag :key="index" v-for="(tag, index) in dynamicTags" :closable="!getDisabled" :type="selectDataIndex==index?'':'info'" :disable-transitions="false" @click="selectData(index,tag)" @close="handleClose(tag)">
            {{tag.name}}
        </el-tag>
        <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput" size="small" style="width: 300px;" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm" placeholder="请输入逻辑库Schema名称">
        </el-input>
        <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 新增schema</el-button>
        <div v-for="(tag, index) in dynamicTags" class="box-dynamicTags">
            <!-- 搜索 -->
            <div class="search_box" v-if="selectDataIndex == index">
                <el-form :model="tag" ref="ruleForm" label-width="180px" :disabled="getDisabled" class="demo-ruleForm" inline>
                    <el-form-item label="逻辑库Schema名称:" label-width="150px" prop="name" maxlength="50" :rules="[
                        {required: true, message: '名称不能为空',trigger: 'blur'},
                        {min: 1, max: 50, message: '名称不能超过50个字符', trigger: 'blur'}
                    ]">
                        <el-input v-model="tag.name" placeholder="名称不能超过50个字符"></el-input>
                    </el-form-item>
                    <el-form-item label="逻辑库Schema描述:" label-width="150px" prop="description"
                    :rules="[
                        {required: true, message: '描述不能为空',trigger: 'blur'},
                    ]">
                        <el-input v-model="tag.description" placeholder="请输入描述"></el-input>
                    </el-form-item>
                    <el-form-item label-width="0px" label=" ">
                        <el-button type="primary" class="button-new-tag" style="margin-left: -10px;" size="small" @click="editSchemaClick">保存</el-button>
                    </el-form-item>
                    <el-button class="button-new-tag floatButton" size="small" type="primary" @click="addForm">+ 新增table</el-button>
                </el-form>
            </div>
            <!-- table -->
            <el-table v-if="selectDataIndex == index" :data="tableData" border highlight-current-row style="margin-top: 24px;" :header-cell-style="{ background: '#f2f2f2' }">
                <el-table-column label="序号" type="index" align="center" width="100">
                </el-table-column>
                <el-table-column prop="name" label="逻辑库Table名称" align="center">
                </el-table-column>
                <el-table-column prop="topicName" label="Topic选择" align="center">
                </el-table-column>
                <el-table-column prop="name" align="center" label="文件切分策略">
                    <template slot-scope="scope">
                        <span>{{scope.row.splitFileType == 1 ? '按数据进入sink时间' : scope.row.splitFileType == 2 ? '按数据进入pipeline时间' : scope.row.splitFileType == 3 ? '按数据字段中的时间' : '按业务库中数据变更发生的时间' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="partitionBasedColumns" align="center" label="分区使用的字段列表">
                </el-table-column>
                <el-table-column prop="encryptColumns" align="center" label="需加密字段">
                </el-table-column>
                <el-table-column prop="splitColumnType" align="center" min-width="120" label="数据时间字段的数据类型">
                    <template slot-scope="scope">
                        <span>{{scope.row.splitColumnType == 1 ? '字符串' : scope.row.splitColumnType == 2 ? 'Long' : '' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="name" align="center" label="操作">
                    <template slot-scope="scope">
                        <el-button @click="editTable(scope.row)" type="primary" size="small">编辑
                        </el-button>
                        <el-button @click="deleteTable(scope.row)" type="error" size="small">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <dialog-tips :show.sync="show" @getCancel="resetForm('ruleForms')" @getConfirm="handleConfirm('ruleForms')" width="800">
            <div slot="boxForm" class="radio-box">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForms" label-width="178px" class="demo-ruleForm">
                    <el-form-item label="逻辑库Table名称：" prop="name">
                        <el-input v-model="ruleForm.name" placeholder="名称不能超过50个字符"></el-input>
                    </el-form-item>
                    <el-form-item label="Topic选择：" prop="kafkaId">
                        <el-col :span="11">
                            <el-select v-model="ruleForm.kafkaId" placeholder="请选择kafka集群" @change="getListByKafkaClusterID">
                                <el-option :label="item.name" :value="item.id" v-for="item in kafkaList"></el-option>
                            </el-select>
                        </el-col>
                        <el-col class="line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-select v-model="ruleForm.topicId" placeholder="请选择Topic">
                                <el-option :label="item.name" :value="item.id" v-for="item in topicList"></el-option>
                            </el-select>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="文件切分策略：" prop="splitFileType">
                        <el-select v-model="ruleForm.splitFileType" placeholder="请选择文件切分策略">
                            <el-option label="按数据进入sink时间" :value="1"></el-option>
                            <el-option label="按数据进入pipeline时间" :value="2"></el-option>
                            <el-option label="按数据字段中的时间" :value="3"></el-option>
                            <el-option label="按业务库中数据变更发生的时间" :value="4"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="数据时间字段类型：" prop="splitColumnType" v-if="ruleForm.splitFileType == 3">
                        <el-select v-model="ruleForm.splitColumnType" style="width: 250px;" placeholder="请选择数据时间字段的数据类型">
                            <el-option label="字符串" :value="1"></el-option>
                            <el-option label="Long" :value="2"></el-option>
                        </el-select>
                        <el-input v-model="ruleForm.splitColumnStrFormat" v-if="ruleForm.splitColumnType==1" placeholder="字符串类型数据格式" class="stingClass"></el-input>
                    </el-form-item>
                    <el-form-item label="数据时间字段名称：" prop="splitColumnName" v-if="ruleForm.splitFileType == 3">
                        <el-input type="text" v-model="ruleForm.splitColumnName" placeholder="请输入数据时间字段名称"></el-input>
                    </el-form-item>
                    <el-form-item label="分区使用的字段列表：" prop="partitionBasedColumns">
                        <el-input type="textarea" v-model="ruleForm.partitionBasedColumns" placeholder="多个字段间用逗号分隔"></el-input>
                    </el-form-item>
                    <el-form-item label="需加密字段：" prop="encryptColumns">
                        <el-input type="textarea" v-model="ruleForm.encryptColumns" placeholder="多个字段间用逗号分隔"></el-input>
                    </el-form-item>
                    <el-form-item label="描述：" prop="description">
                        <el-input type="textarea" v-model="ruleForm.description" placeholder="请输入描述"></el-input>
                    </el-form-item>
                </el-form>
            </div>
        </dialog-tips>
    </div>
</template>
<script>
import DialogTips from "@/components/dialogTips";
import {
    addOrEditLogicalTable,
    deleteLogicalTable,
    getListBySchemaIDOfLogical,
    addOrEditSchemaIDByLogical,
    deleteLogicalSchema,
    getLogicalListByDataBaseId
} from "@/apis/pipelineService/logicalDb";
import {
    getListByKafkaClusterID,
    getKafkaList
} from "../../../apis/pipelineService/kafkaService";
export default {
    data() {
        return {
            tableData: [],
            isSchemaEdit: false,
            moduleName: "",
            inputValue: "", // 输入框input
            dynamicTags: [],
            inputVisible: false,
            selectDataIndex: 0, // 选中key)
            selectValue: {}, // 选中data
            show: false,
            ruleForm: {
                id: "", // 主键id
                logicalSchemaId: "", // 逻辑库中schema或database的ID
                name: "", // 数据表名
                topicId: "",
                encryptColumns: "", // 需要加密的字段名称用逗号分隔
                splitColumnType: "", // 数据时间字段的数据类型 1字符串 2Long
                splitFileType: "", // 文件切分策略ID 1按数据进入Sink时间 2按数据进入pipeline时间 3按数据字段中的时间
                splitColumnStrFormat: "", // 数据时间字段为字符串类型时的字符串格式
                partitionBasedColumns: "", // 分区使用的字段列表多个字段用逗号分隔
                kafkaId: "", // kafaka集群
                description: "",
                splitColumnName: '', // 数据时间字段的数据名称
            },
            kafkaList: [], //集群列表
            topicList: [], // topicList
            rules: {
                name: [
                    {
                        required: true,
                        message: "请输入逻辑库table名称",
                        trigger: "blur"
                    },
                    {
                        min: 1,
                        max: 50,
                        message: "名称不能超过50个字符",
                        trigger: "blur"
                    }
                ],
                topicId: [
                    {
                        required: true,
                        message: "请选择topic",
                        trigger: "change"
                    }
                ],
                splitFileType: [
                    {
                        required: true,
                        message: "请选择文件切分策略",
                        trigger: "change"
                    }
                ],
                splitColumnStrFormat: [
                    {
                        required: true,
                        message: "请输入字符串格式",
                        trigger: "blur"
                    }
                ],
                splitColumnType: [
                    {
                        required: true,
                        message: "请选择数据时间字段的数据类型",
                        trigger: "change"
                    }
                ],
                splitColumnName: [
                    {
                        required: true,
                        message: "请输入数据时间字段的名称",
                        trigger: "blur"
                    },
                    {
                        min: 1,
                        max: 50,
                        message: "名称不能超过50个字符",
                        trigger: "blur"
                    }
                ],
                partitionBasedColumns: [
                    {
                        required: true,
                        message: "请填写分区使用的字段列表",
                        trigger: "change"
                    }
                ],
                kafkaId: [
                    {
                        required: true,
                        message: "请先选择kafka集群",
                        trigger: "change"
                    }
                ],
                description: [
                    {
                        required: true,
                        message: "请输入描述",
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    mounted() {
        this.selectValue = this.dynamicTags[0];
        if (this.$route.query.type != "add") {
            this.getLogicalListByDataBaseId(); // 加载逻辑库schema列表
        }
    },
    components: {
        DialogTips
    },
    computed: {
        getDisabled() {
            return {
                add: false,
                edit: false,
                details: true
            }[this.$route.query.type];
        },
        // showSplitStatus() {
        //     if (this.ruleForm.splitFileType == 1 || this.ruleForm.splitFileType == 2) {
        //         return false
        //     } else {
        //         return true
        //     }
        // }
    },
    watch: {},
    methods: {
        // 新增Table
        addForm() {
            this.ruleForm.id = "";
            if (!this.selectValue.id) {
                this.$message.error(
                    "请填写逻辑库schemema名称和逻辑库Schema描述"
                );
                return false;
            }
            this.getTotalList();
            this.show = true;
        },
        // 删除Schema
        handleClose(tag) {
            if (!tag.id) {
                this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
                return false;
            }
            this.deleteData(tag, "Schema");
        },
        showInput() {
            this.inputVisible = true;
            this.inputValue = "";
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },
        // 新增Schema 按钮
        handleInputConfirm() {
            let inputValue = this.inputValue;
            if (inputValue && !this.isFlag) {
                this.dynamicTags.push({
                    name: this.inputValue,
                    id: "",
                    description: ""
                });
                this.inputVisible = false;
                this.selectDataIndex = this.dynamicTags.length - 1;
                this.selectValue = this.dynamicTags[this.selectDataIndex];
                this.tableData = [];
            } else {
                this.inputVisible = false;
            }
        },
        // 修改Schema 按钮
        editTopClick() {
            this.isSchemaEdit = !this.isSchemaEdit;
            if (!this.isSchemaEdit) {
                this.addOrEditSchemaIDByLogical("edit");
            }
        },
        // 编辑table
        editTable(data) {
            this.show = true;
            //回显数据
            this.$nextTick(function() {
                this.ruleForm.kafkaId = data.kafkaId;
                this.getTotalList();
                this.ruleForm = { ...data };
            });
        },
        // 删除table
        deleteTable(data) {
            this.deleteData(data, "Table");
        },
        // 选择Topic
        selectData(index, tag) {
            if (this.selectDataIndex == index) {
                return false;
            }
            this.tableData = [];
            this.selectDataIndex = index;
            this.selectValue = tag;
            this.getListBySchemaIDOfLogical(); // 获取当前schame下的table
        },
        // 获取schema列表
        async getLogicalListByDataBaseId() {
            let params = {
                logicalDataBaseID: this.$route.query.id // 集群id
            };
            try {
                const data = await getLogicalListByDataBaseId(params);
                if (data.code == 0 && data.data) {
                    this.dynamicTags = data.data;
                    if (this.dynamicTags && this.dynamicTags.length > 0) {
                        this.selectValue = this.dynamicTags[0];
                        this.selectDataIndex = 0;
                        this.getListBySchemaIDOfLogical();
                    }
                }
            } catch (error) {}
        },
        // 根据schemaId获取table列表
        async getListBySchemaIDOfLogical() {
            let params = {
                logicalSchemaID: this.selectValue.id
            };
            try {
                const data = await getListBySchemaIDOfLogical(params);
                if (data.code == 0 && data.data) {
                    this.tableData = data.data;
                }
            } catch (error) {}
        },
        // 新增或修改schema
        async addOrEditSchemaIDByLogical() {
            let params = {
                logicalDbId: this.$route.query.id || this.id,
                name: this.inputValue || this.selectValue.name,
                id: this.selectValue.id,
                description: this.selectValue.description
                    ? this.selectValue.description
                    : " "
            };
            if (!this.selectValue.id) {
                delete params.id;
            }
            try {
                const data = await addOrEditSchemaIDByLogical(params);
                if (data.code == 0) {
                    this.$message.success(data.message || "保存成功");
                    if (!this.selectValue.id) {
                        this.selectValue.id = data.data.id;
                        this.inputValue = "";
                    }
                } else {
                    this.$message.error(data.message || "保存失败");
                    this.inputValue = null;
                    this.inputVisible = false;
                }
            } catch (error) {}
        },
        // 新增或修改table保存
        async addOrEditLogicalTable(type) {
            let params = {
                ...this.ruleForm,
                logicalSchemaId:
                    this.ruleForm.logicalSchemaId || this.selectValue.id
            };
            if (!this.ruleForm.id) {
                delete params.id;
            }
            try {
                const data = await addOrEditLogicalTable(params);
                if (data.code == 0) {
                    this.$message.success(data.message || "保存成功");
                    this.resetForm("ruleForms");
                    this.getListBySchemaIDOfLogical();
                } else {
                    this.$message.error(data.message || "保存失败");
                }
            } catch (error) {}
        },
        // 保存表单
        handleConfirm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    if (!this.ruleForm.topicId) {
                        this.$message.warning("请选择Topic");
                        return false;
                    }
                    if (
                        this.ruleForm.splitColumnType == 1 &&
                        !this.ruleForm.splitColumnStrFormat
                    ) {
                        this.$message.warning("请填写字符串数据格式");
                        return false;
                    }
                    this.addOrEditLogicalTable();
                } else {
                    return false;
                }
            });
        },
        // 重置form
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.ruleForm.splitColumnStrFormat = ''
            this.ruleForm.splitColumnType = null
            this.show = false;
        },
        // 删除提示
        deleteData(data, type) {
            this.$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    if (type == "Schema") {
                        this.deleteLogicalSchema(data);
                    } else {
                        this.deleteLogicalTable(data);
                    }
                })
                .catch(() => {});
        },
        // 删除Schema接口
        async deleteLogicalSchema(tag) {
            const params = {
                id: tag.id
            };
            try {
                const data = await deleteLogicalSchema(params);
                if (data.code == 0) {
                    this.$message.success(data.message || "删除成功");
                    this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
                    this.getLogicalListByDataBaseId();
                } else {
                    this.$message.error(data.message || "删除失败");
                }
            } catch (error) {}
        },
        // 删除Table接口
        async deleteLogicalTable(tag) {
            const params = {
                id: tag.id // 主键id
            };
            try {
                const data = await deleteLogicalTable(params);
                if (data.code == 0) {
                    this.$message.success(data.message || "删除成功");
                    this.getListBySchemaIDOfLogical();
                    // this.tableData.splice(this.tableData.indexOf(tag), 1);
                } else {
                    this.$message.error(data.message || "删除失败");
                    this.getListBySchemaIDOfLogical();
                }
            } catch (error) {}
        },
        // 保存修改
        editSchemaClick() {
            if (!this.selectValue.name || !this.selectValue.description) {
                this.$message.warning("请输入逻辑库Schema名称和逻辑库Schema描述");
                return false;
            }
            this.addOrEditSchemaIDByLogical("edit");
        },
        // 获取集群列表
        async getKafkaList() {
            const params = {
                current: 1, // 当前页
                size: 10000 // 当前条数
            };
            try {
                const data = await getKafkaList(params);
                if (data.code == 0 && data.data) {
                    this.kafkaList = data.data.records;
                }
                this.message = data.msg;
            } catch (error) {}
        },
        // 根据集群id获取topic列表
        async getListByKafkaClusterID(kafkaClusterID) {
            this.ruleForm.topicId = "";
            let params = {
                kafkaClusterID: kafkaClusterID // 集群id
            };
            try {
                const data = await getListByKafkaClusterID(params);
                if (data.code == 0 && data.data) {
                    this.topicList = data.data;
                }
            } catch (error) {}
        },
        // 获取编辑弹框集群以及topic列表
        getTotalList() {
            this.getKafkaList();
            this.getListByKafkaClusterID(this.ruleForm.kafkaId);
        }
    }
};
</script>
<style lang="less" scoped>
.search_box {
    padding-top: 20px;
}
.el-tag + .el-tag {
    margin-left: 10px;
}
.button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}
.input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
}
.info {
    width: 100%;
    margin: 0 auto;
    background: #f8f8f8;
    border-radius: 10px;
    padding-top: 20px;
    margin-bottom: 20px;
}
h5 {
    font-size: 18px;
    padding: 15px;
    font-weight: 700;
    color: #666;
    border-bottom: 1px solid #ddd;
    margin-bottom: 40px;
}
.edit-title {
    margin-top: 40px;
}
.floatButton {
    float: right;
}
.stingClass {
    width: 200px;
    margin-left: 30px;
}
.box-dynamicTags {
    margin-bottom: 30px;
}
</style>

